import * as React from 'react';
import {cn} from '../../../lib/cn';
import {Drawer, DrawerContent, DrawerDescription, DrawerTitle} from '../../../drawer';

type DateRangePopoverProps = {
  isOpen: boolean;
  isMobile: boolean;
  openDirection: 'up' | 'down';
  drawerTitle: string;
  drawerDescription: string;
  onClose: () => void;
  children: React.ReactNode;
};

export function DateRangePopover({
  isOpen,
  isMobile,
  openDirection,
  drawerTitle,
  drawerDescription,
  onClose,
  children,
}: DateRangePopoverProps) {
  if (!isOpen) return null;

  if (isMobile) {
    return (
      <Drawer
        open={isOpen}
        onOpenChange={next => {
          if (!next) onClose();
        }}
      >
        <DrawerContent
          onClose={onClose}
          lockScroll={false}
          className="max-h-[calc(100vh-1rem)]"
        >
          <DrawerTitle className="sr-only">{drawerTitle}</DrawerTitle>
          <DrawerDescription className="sr-only">{drawerDescription}</DrawerDescription>
          <div className="flex items-start justify-center overflow-x-auto px-2 pb-4 pt-1">
            {children}
          </div>
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <div
      className={cn(
        'absolute left-0 z-30 w-max overflow-hidden rounded-[3px] border border-[var(--chekin-color-brand-blue)] bg-white shadow-[0_5px_5px_0_rgba(33,72,255,0.1)]',
        openDirection === 'up' ? 'bottom-full mb-2' : 'top-full mt-1',
      )}
    >
      {children}
    </div>
  );
}
